import { PORTAL_API_BASE_URL } from '../../../../constants';
import request from '../../../../util/APIUtils';

const BASE = `${PORTAL_API_BASE_URL}/api/person`;
const req = (opts) => request({ ...opts, throw400Error: true });

/** @returns {Promise<Array<{ id: number, name: string, description: string|null }>>} */
export function getAttributeTypes() {
  return req({ url: `${BASE}/attribute-types`, method: 'GET' });
}

/** @returns {Promise<Array>} */
export function getPersonAttributes(personId) {
  return req({ url: `${BASE}/${encodeURIComponent(personId)}/attributes`, method: 'GET' });
}

export function createPersonAttribute(personId, body) {
  return req({
    body: JSON.stringify(body),
    method: 'POST',
    url: `${BASE}/${encodeURIComponent(personId)}/attributes`,
  });
}

export function updatePersonAttribute(personId, assnId, body) {
  return req({
    body: JSON.stringify(body),
    method: 'PUT',
    url: `${BASE}/${encodeURIComponent(personId)}/attributes/${encodeURIComponent(assnId)}`,
  });
}

export function deletePersonAttribute(personId, assnId) {
  return req({
    method: 'DELETE',
    url: `${BASE}/${encodeURIComponent(personId)}/attributes/${encodeURIComponent(assnId)}`,
  });
}
